import cx from 'classnames'
import { Check02 } from 'blaze-ui/icons/16'
import { VisualStyle } from 'hooks/queries/visualStyles'
import Styles from './VisualStyleCard.module.scss'

export interface VisualStyleCardProps {
  style: VisualStyle
  isSelected: boolean
  onSelect: () => void
}

export const VisualStyleCard = ({ style, isSelected, onSelect }: VisualStyleCardProps) => {
  return (
    <div className={cx(Styles.card, { [Styles.selected]: isSelected })} onClick={onSelect}>
      <img src={style.cover_image_url} alt={style.name} className={Styles.image} />
      <div className={cx(Styles.label, { [Styles.selectedLabel]: isSelected })}>{style.name}</div>
      {isSelected && (
        <div className={Styles.checkbox}>
          <Check02 size={12} color="var(--dark-80)" />
        </div>
      )}
    </div>
  )
}

export const VisualStyleCardSkeleton = () => {
  return <div className={cx(Styles.card, Styles.loading)} />
}
